(function () {
  var root = document.querySelector('[data-pu-explainer]');
  if (!root) return;

  if (root.classList.contains('pu-explainer-page--hbot')) {
    var bodyStep = root.querySelector('#explainer-step-4');
    var namedActions = bodyStep && bodyStep.querySelector('.pu-explainer-step__actions');
    if (namedActions) {
      var mechanisms = namedActions.querySelector('[data-why-disclosure-open="hbot-m4"]');
      var goals = namedActions.querySelector('[data-why-disclosure-open="hbot-m4b"]');
      if (mechanisms && goals) {
        mechanisms.dataset.popupLabel = '13 ways it works';
        goals.dataset.popupLabel = 'Applied to real goals';
        goals.hidden = false;
        goals.classList.add('pu-action-plus');
        namedActions.classList.add('pu-explainer-step__actions--named');
        if (!namedActions.querySelector('.pu-explainer-study-link')) {
          var studies = document.createElement('a');
          studies.className = 'pu-explainer-study-link';
          studies.href = '/blogs/studies';
          studies.textContent = 'Clinical studies';
          namedActions.appendChild(studies);
        }
        bodyStep.querySelector('.pu-explainer-step__body').appendChild(namedActions);
      }
    }
  }

  /* Ricardo-approved popup label: make the action explicit without changing
     the shared dialog binding or the no-JavaScript disclosure fallback. */
  if (root.matches('.pu-explainer-page--hbot, .pu-explainer-page--red-light')) {
    root.querySelectorAll('.pu-action-plus[data-why-disclosure-open]').forEach(function (button) {
      if (button.classList.contains('pu-action-pill')) return;
      var title = button.dataset.disclosureTitle || button.getAttribute('aria-label') || '';
      var actionLabel = button.dataset.popupLabel || 'Learn more';
      var label = document.createElement('span');
      label.className = 'pu-action-pill__label';
      label.textContent = actionLabel;
      var plus = document.createElement('span');
      plus.className = 'pu-action-pill__plus';
      plus.setAttribute('aria-hidden', 'true');
      plus.textContent = '+';
      button.replaceChildren(label, plus);
      button.classList.replace('pu-action-plus', 'pu-action-pill');
      button.setAttribute('aria-label', button.dataset.popupLabel ? actionLabel : 'Learn more' + (title ? ': ' + title : ''));
    });
  }

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;
  function ease(p) { return 1 - Math.pow(1 - p, 3); }

  var heroVideo = root.querySelector('[data-explainer-hero-video]');
  var heroToggle = root.querySelector('[data-explainer-hero-toggle]');
  if (heroVideo && heroToggle) {
    var heroMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var heroInView = !hasIO;
    var heroPaused = false;
    var heroRequested = false;
    var heroFailed = false;
    var heroPending = false;
    function labelHeroVideo() {
      heroToggle.textContent = heroFailed ? 'Retry video' : heroVideo.paused ? 'Play video' : 'Pause video';
      heroToggle.setAttribute('aria-label', heroFailed ? 'Retry background video' : heroVideo.paused ? 'Play background video' : 'Pause background video');
    }
    /* Start the footage 250 ms after the hero still has painted, never during the initial
       paint: on slow devices the request otherwise joins the LCP dependency graph. */
    var heroPaintReady = false;
    var heroPaintScheduled = false;
    function heroPaintDone() {
      if (heroPaintScheduled) return;
      heroPaintScheduled = true;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          window.setTimeout(function () { heroPaintReady = true; syncHeroVideo(); }, 250);
        });
      });
    }
    (function scheduleHeroPaint() {
      var still = heroVideo.parentElement ? heroVideo.parentElement.querySelector('img') : null;
      try {
        if (still) {
          var whenDecoded = function () {
            if (typeof still.decode === 'function') still.decode().then(heroPaintDone, heroPaintDone);
            else heroPaintDone();
          };
          if (still.complete) whenDecoded();
          else {
            still.addEventListener('load', whenDecoded, { once: true });
            still.addEventListener('error', heroPaintDone, { once: true });
          }
        } else heroPaintDone();
      } catch (error) { heroPaintDone(); }
      window.setTimeout(function () { if (!heroPaintReady) { heroPaintReady = true; syncHeroVideo(); } }, 6000);
    })();
    function syncHeroVideo() {
      var shouldPlay = heroInView && !document.hidden && !heroPaused && !heroFailed &&
        (heroRequested || (!heroMotion.matches && !(navigator.connection && navigator.connection.saveData)));
      if (!shouldPlay) {
        heroVideo.pause();
        labelHeroVideo();
        return;
      }
      if (!heroPaintReady && !heroRequested) return;
      if (heroPending || !heroVideo.paused) return;
      var source = heroVideo.querySelector('source');
      if (source && !source.getAttribute('src')) { source.src = source.dataset.src; heroVideo.load(); }
      heroVideo.muted = true;
      heroVideo.defaultMuted = true;
      heroPending = true;
      Promise.resolve(heroVideo.play()).catch(function (error) {
        if (error.name !== 'AbortError') heroPaused = true;
      }).finally(function () { heroPending = false; labelHeroVideo(); });
    }
    heroVideo.addEventListener('playing', function () { heroVideo.classList.add('is-playing'); labelHeroVideo(); });
    heroVideo.addEventListener('pause', labelHeroVideo);
    heroVideo.addEventListener('error', function () {
      heroFailed = true;
      heroVideo.classList.remove('is-playing');
      labelHeroVideo();
    });
    heroToggle.hidden = false;
    heroToggle.addEventListener('click', function () {
      if (!heroVideo.paused) { heroPaused = true; syncHeroVideo(); return; }
      if (heroFailed) { heroFailed = false; heroVideo.load(); }
      heroPaused = false;
      heroRequested = true;
      syncHeroVideo();
    });
    if (hasIO) {
      var heroObserver = new IntersectionObserver(function (entries) {
        heroInView = entries[0].isIntersecting;
        syncHeroVideo();
      }, { threshold: .05 });
      heroObserver.observe(heroVideo.parentElement);
    } else syncHeroVideo();
    heroMotion.addEventListener('change', syncHeroVideo);
    document.addEventListener('visibilitychange', syncHeroVideo);
  }

  /* Step films: load and play only while on screen. Posters stay put when
     motion is reduced, the tab is hidden, or playback is refused. */
  var videos = [].slice.call(root.querySelectorAll('[data-explainer-video]'));
  function playVideo(video) {
    var source = video.querySelector('source');
    if (source && !source.getAttribute('src')) {
      source.src = source.dataset.src;
      video.load();
    }
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    var playing = video.play();
    if (playing) playing.catch(function () {});
  }
  if (videos.length && hasIO && !reduce) {
    var videoObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.dataset.onScreen = entry.isIntersecting ? 'true' : '';
        if (entry.isIntersecting && !document.hidden) playVideo(entry.target);
        else entry.target.pause();
      });
    }, { rootMargin: '120px 0px' });
    videos.forEach(function (video) { videoObserver.observe(video); });
    document.addEventListener('visibilitychange', function () {
      videos.forEach(function (video) {
        if (document.hidden) video.pause();
        else if (video.dataset.onScreen) playVideo(video);
      });
    });
  }

  /* A link inside one "full picture" that opens another: close it, then open. */
  root.addEventListener('click', function (event) {
    var link = event.target.closest('[data-explainer-open-detail]');
    if (!link) return;
    event.preventDefault();
    var close = root.querySelector('[data-why-disclosure-close]');
    if (close) close.click();
    var trigger = root.querySelector('[data-why-disclosure-open="' + link.dataset.explainerOpenDetail + '"]');
    if (trigger) window.requestAnimationFrame(function () { trigger.click(); });
  });

  /* Count-ups: the markup already carries the final figure for no-JS and
     reduced-motion readers; only animate when it is safe to. */
  var counts = [].slice.call(root.querySelectorAll('[data-explainer-count]'));
  function countText(node, value) {
    return (node.dataset.explainerPrefix || '') + value.toLocaleString('en-GB') + (node.dataset.explainerSuffix || '');
  }
  if (counts.length && hasIO && !reduce) {
    var countObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        countObserver.unobserve(entry.target);
        var node = entry.target;
        var target = Number(node.dataset.explainerCount);
        var start = null;
        var duration = 1200;
        function tick(now) {
          if (!start) start = now;
          var progress = Math.min(1, (now - start) / duration);
          node.textContent = countText(node, Math.round(target * ease(progress)));
          if (progress < 1) requestAnimationFrame(tick);
          else node.textContent = countText(node, target);
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.6 });
    counts.forEach(function (node) {
      node.textContent = countText(node, 0);
      countObserver.observe(node);
    });
  }

  /* Plasma oxygen dials (step 3). */
  var CIRCUMFERENCE = 326.7;
  var dials = [].slice.call(root.querySelectorAll('[data-explainer-dial]'));
  function dialText(value) { return (value > 0 ? '+' : '') + value.toLocaleString('en-GB') + '%'; }
  function dialFinal(dial) {
    var value = dial.querySelector('[data-explainer-dial-value]');
    var fill = dial.querySelector('.pu-explainer-dial__fill');
    value.textContent = dialText(Number(dial.dataset.target));
    fill.style.strokeDashoffset = CIRCUMFERENCE * (1 - Number(dial.dataset.frac));
  }
  if (dials.length) {
    if (!hasIO || reduce) {
      dials.forEach(dialFinal);
    } else {
      var dialObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          dialObserver.unobserve(entry.target);
          var dial = entry.target;
          var value = dial.querySelector('[data-explainer-dial-value]');
          var fill = dial.querySelector('.pu-explainer-dial__fill');
          var target = Number(dial.dataset.target);
          var frac = Number(dial.dataset.frac);
          var start = null;
          var duration = 1400;
          function tick(now) {
            if (!start) start = now;
            var progress = Math.min(1, (now - start) / duration);
            var eased = ease(progress);
            value.textContent = dialText(Math.round(target * eased));
            fill.style.strokeDashoffset = CIRCUMFERENCE * (1 - frac * eased);
            if (progress < 1) requestAnimationFrame(tick);
            else dialFinal(dial);
          }
          requestAnimationFrame(tick);
        });
      }, { threshold: 0.45 });
      dials.forEach(function (dial) {
        dial.querySelector('[data-explainer-dial-value]').textContent = dialText(0);
        dialObserver.observe(dial);
      });
    }
  }

  /* "N of 8" counter: shown while the steps are on screen, tracking the step
     nearest the reading line (the wireframe's side rail). */
  var steps = [].slice.call(root.querySelectorAll('[data-explainer-step]'));
  var rail = root.querySelector('[data-explainer-rail]');
  if (rail && steps.length) {
    var current = rail.querySelector('[data-explainer-rail-current]');
    var progress = rail.querySelector('[data-explainer-rail-progress]');
    var ticking = false;
    function updateRail() {
      ticking = false;
      var line = window.innerHeight * 0.45;
      var index = 0;
      for (var i = 0; i < steps.length; i++) {
        if (steps[i].getBoundingClientRect().top <= line) index = i;
      }
      if (current) current.textContent = String(index + 1);
      if (progress) progress.style.setProperty('--pu-step-progress', ((index + 1) / steps.length * 100) + '%');
      var first = steps[0].getBoundingClientRect();
      var last = steps[steps.length - 1].getBoundingClientRect();
      rail.classList.toggle('is-on', first.top < window.innerHeight * 0.7 && last.bottom > line);
    }
    function requestRail() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateRail);
    }
    window.addEventListener('scroll', requestRail, { passive: true });
    window.addEventListener('resize', requestRail);
    window.addEventListener('pageshow', requestRail);
    root.addEventListener('load', requestRail, true);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', requestRail);
    if (document.fonts) document.fonts.ready.then(requestRail);
    updateRail();
  }

  /* Podcast: keep the poster until someone asks for the video. */
  [].slice.call(root.querySelectorAll('[data-explainer-film]')).forEach(function (film) {
    var play = film.querySelector('[data-explainer-film-play]');
    if (!play) return;
    play.addEventListener('click', function (event) {
      event.preventDefault();
      if (film.dataset.state === 'ready') return;
      var frame = document.createElement('iframe');
      frame.src = 'https://www.youtube-nocookie.com/embed/' + film.dataset.videoId + '?start=' + (film.dataset.start || '0') + '&autoplay=1&playsinline=1&rel=0';
      frame.title = film.dataset.videoTitle || 'Video';
      frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      frame.allowFullscreen = true;
      frame.referrerPolicy = 'strict-origin-when-cross-origin';
      film.appendChild(frame);
      film.dataset.state = 'ready';
      play.hidden = true;
      frame.focus();
    });
  });
})();
